module.exports = __webpack_public_path__ + "img/RasFamilie.44694d95.png";